export default {"src":"/_next/static/media/white-room-names-en.7e897c37.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};